import React from "react";

import { useCoverForContext } from "../../../provider/cover-for.provider";

function CoverForDescriptionTitle() {
  const { groupedCmsData, selectedAnswer } = useCoverForContext();
  const { title } = groupedCmsData[selectedAnswer].descriptionSection;

  return (
    <h2
      className={`
        md:!text-3xl font-header-font ${
          selectedAnswer === "DEFAULT"
            ? "text-center"
            : "text-center md:text-left"
        } leading-[21px] 
        md:leading-[34.1px] text-[20px] md:mb-spacing-xs mb-spacing-m text-dark-text-on-primary"
      `}
    >
      {title}
    </h2>
  );
}

export default CoverForDescriptionTitle;
